<header class="page-header">
  <div>
    <h1 class="page-title">{{ 'pages.roles.title' | translate }}</h1>
    <p class="page-subtitle">{{ 'pages.roles.subtitle' | translate }}</p>
  </div>

  <button class="btn btn-primary" type="button" (click)="requestCreate()">
    <i class="fa-solid fa-plus" aria-hidden="true"></i>
    {{ 'pages.roles.actions.create' | translate }}
  </button>
</header>
